<template>
  <div
    class="pill mx-0-25 flex w-auto grow-0 items-center justify-center rounded-full px-2 py-0 text-center text-xs font-semibold"
  >
    {{ count }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { DEFAULT_RELATION_COLOR } from "@/helpers/constants/entityProfiles";

const props = defineProps({
  count: {
    type: Number,
  },
  color: {
    type: String,
    default: DEFAULT_RELATION_COLOR,
  },
});

const textColor = computed(() => {
  if (props.color.includes("#")) {
    return props.color;
  }
  return `rgb(${props.color})`;
});

const bgColor = computed(() => {
  if (props.color.includes("#")) {
    return `${props.color}1A`;
  }
  return `rgba(${props.color}, 0.1)`;
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.pill {
  color: v-bind(textColor);
  background-color: v-bind(bgColor);
}
</style>
